$(function() {
  $('#unsupportedBrowserDisclaimer .close-icon').click(function() {
    $('#unsupportedBrowserDisclaimer').remove();
  });

  $('#unsupportedBrowserModal').modal('show');
});
